import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import moment from 'moment';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import UserEdit from '../UserEdit';
import getUsers from '../getUsers.api';
import Results from './Results';
import SearchFilter from './SearchFilter';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    },
    filter: {
        width: '100%',
        height: 30,
    }
}));

export interface FilterValues {
    email: string,
    first_name: string,
    last_name: string,
    role: string,
    roles: string[],
    cellphone: string,
    created_after: Date,
    emailVerifiedTrue: boolean,
    emailVerifiedFalse: boolean,
    adminVerifiedTrue: boolean,
    adminVerifiedFalse: boolean,
    disabledTrue: boolean,
    disabledFalse: boolean,
}

const UserList = () => {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [openEdit, setOpenEdit] = useState(false);
    const title = 'User List';

    const handleEditOpen = () => {
        setOpenEdit(true);
    };

    const handleEditClose = () => {
        setOpenEdit(false);
    };

    const handleSearch = (value: string) => {
        const whereConstraints: WhereConstraints = {
            OR: [
                {column: 'first_name', operator: OPERATOR.LIKE, value: `%${value}%`},
                {column: 'last_name', operator: OPERATOR.LIKE, value: `%${value}%`},
                {column: 'email', operator: OPERATOR.LIKE, value: `%${value}%`},
            ]
        };

        setFilters(initialFilters);
        setWhere(whereConstraints);
    };

    const initialFilters: FilterValues = {
        email: '',
        first_name: '',
        last_name: '',
        cellphone: '',
        created_after: moment('2019-01-01T00:00').toDate(),
        role: '',
        roles: new Array<string>(),
        emailVerifiedTrue: false,
        emailVerifiedFalse: false,
        adminVerifiedTrue: false,
        adminVerifiedFalse: false,
        disabledTrue: false,
        disabledFalse: false,
    };

    const applyFilters = (newFilters: FilterValues) => {
        setFilters(newFilters);
        setWhere(getConstraintsFromFilters(newFilters));
    };

    const getConstraintsFromFilters = (newFilters: FilterValues) => {
        const whereConstraints: WhereConstraints = {
            AND: [],
        };

        //whereConstraints.AND!.push({column: 'created_at', operator: OPERATOR.GTE, value: newFilters.created_after});
        if (newFilters.email.length > 0) whereConstraints.AND!.push({
            column: 'email',
            operator: OPERATOR.LIKE,
            value: `%${newFilters.email}%`
        });
        if (newFilters.first_name.length > 0) whereConstraints.AND!.push({
            column: 'first_name',
            operator: OPERATOR.LIKE,
            value: `%${newFilters.first_name}%`
        });
        if (newFilters.last_name.length > 0) whereConstraints.AND!.push({
            column: 'last_name',
            operator: OPERATOR.LIKE,
            value: `%${newFilters.last_name}%`
        });
        if (newFilters.cellphone.length > 0) whereConstraints.AND!.push({
            column: 'cellphone',
            operator: OPERATOR.LIKE,
            value: `%${newFilters.cellphone}%`
        });
        if (newFilters.emailVerifiedTrue) whereConstraints.AND!.push({
            column: 'email_verified',
            operator: OPERATOR.EQ,
            value: true
        });
        if (newFilters.emailVerifiedFalse) whereConstraints.AND!.push({
            column: 'email_verified',
            operator: OPERATOR.EQ,
            value: false
        });
        if (newFilters.adminVerifiedTrue) whereConstraints.AND!.push({
            column: 'admin_verified',
            operator: OPERATOR.EQ,
            value: true
        });
        if (newFilters.adminVerifiedFalse) whereConstraints.AND!.push({
            column: 'admin_verified',
            operator: OPERATOR.EQ,
            value: false
        });
        if (newFilters.disabledTrue) whereConstraints.AND!.push({
            column: 'disabled',
            operator: OPERATOR.EQ,
            value: true
        });
        if (newFilters.disabledFalse) whereConstraints.AND!.push({
            column: 'disabled',
            operator: OPERATOR.EQ,
            value: false
        });
        //whereConstraints.AND!.push({column: 'admin_verified', operator: OPERATOR.EQ, value: newFilters.adminVerified});
        //whereConstraints.AND!.push({column: 'disabled', operator: OPERATOR.EQ, value: newFilters.disabled});

        // const roleConstraints :WhereConstraints = {OR: [],};
        // newFilters.roles.map(tag => roleConstraints.OR!.push({column: 'ident', operator: OPERATOR.EQ, value: tag}));
        // whereConstraints.AND!.push(roleConstraints);

        return whereConstraints;
    };

    const [filters, setFilters] = useState(initialFilters);
    const [where, setWhere] = useState(getConstraintsFromFilters(initialFilters));
    const [orderBy, setOrderBy] = useState([{column: 'last_name', order: 'ASC'}]);
    const usersData = getUsers(rowsPerPage, page, where, orderBy);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="Users" title={title} action={{
                permission: 'user.create',
                label: 'Add User',
                onClick: handleEditOpen,
            }}/>
            <SearchBar onSearch={handleSearch}
                       filterContent={<SearchFilter applyFilters={applyFilters} filters={filters}
                                                    initialFilters={initialFilters}/>}/>
            <LoadingOverlay loading={usersData.loading}>
                {usersData.data && usersData.data.users && (
                    <Results
                        className={classes.results}
                        users={usersData.data.users.data}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        paginatorInfo={usersData.data.users.paginatorInfo}
                        setPage={setPage}
                    />
                )}
            </LoadingOverlay>
            <UserEdit
                user={{}}
                onClose={handleEditClose}
                open={openEdit}
            />
        </Page>
    );
};

export default UserList;
